export enum PersonType {
	Designer = "designer",
	Artist = "artist",
	Publisher = "publisher",
}
